import { defineComponent as _defineComponent } from 'vue';
import InputText from 'primevue/inputtext';
import Button from 'primevue/button';
import DataTable from '@/Components/DataTable.vue';
import Column from 'primevue/column';
import { FilterMatchMode, FilterOperator } from 'primevue/api';
import Calendar from 'primevue/calendar';
import { onMounted, ref, computed } from 'vue';
import { usePage } from '@inertiajs/inertia-vue3';
import { Inertia } from '@inertiajs/inertia';
import { useMitt } from '../../../Plugins/mitt';
import RecordsTableHeader from '../../../Components/RecordsTableHeader.vue';
import { formatISODate } from '../../../Services/Utils';
export default /*#__PURE__*/ _defineComponent({
    __name: 'Table',
    setup(__props, { expose }) {
        expose();
        const emitter = useMitt();
        const selectedRecords = ref();
        const filters = ref({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            code: {
                operator: FilterOperator.AND,
                constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
            },
            date: {
                operator: FilterOperator.AND,
                constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }],
            },
        });
        const globalFilterFields = ['code', 'description'];
        const page = usePage();
        const irrigationWaterData = computed(() => page.props.value.irrigationWaterData || []);
        const reloadRecords = () => {
            Inertia.reload({
                only: ['irrigationWaterData'],
            });
        };
        onMounted(() => reloadRecords());
        const edit = (data) => emitter.emit('open-irrigation-water-data-form', data);
        emitter.on('irrigation-water-data-saved', () => reloadRecords());
        const __returned__ = { emitter, selectedRecords, filters, globalFilterFields, page, irrigationWaterData, reloadRecords, edit, get InputText() { return InputText; }, get Button() { return Button; }, DataTable, get Column() { return Column; }, get Calendar() { return Calendar; }, RecordsTableHeader, get formatISODate() { return formatISODate; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
